export const state = {
    patientType: null,
    stateCode: null,
    isVeteran: false,
    hasVeteranFile: false,
    veteranFileId: null,
    plan: null,
    dateISO: null,
    timeSlot: null,
    reminder: null,
    priceText: null,
    priceCents: null
};